import React from "react";
import { Link } from "react-router-dom";
import { LayoutDashboard, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export default function PaymentCancel() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--bg)] p-6" data-testid="payment-cancel-page">
      <div className="w-full max-w-md bg-white rounded-2xl border border-[var(--border)] p-10 text-center shadow-lg">
        <Link to="/login" data-testid="payment-cancel-logo-link" className="inline-block hover:opacity-80 transition-opacity">
          <img src="/brand/mpire-logo.png" alt="MPIRE" className="w-14 h-14 mx-auto mb-4" />
        </Link>
        <XCircle className="mx-auto text-gray-400" size={44} />
        <h1 className="text-2xl font-bold mt-4">Checkout cancelled</h1>
        <p className="text-gray-500 mt-2 text-sm">
          No charge was made. Your cart is still saved — feel free to review or continue.
        </p>
        <div className="mt-6 grid gap-2">
          <Button asChild className="btn-brand w-full"><Link to="/shop" data-testid="cancel-back-shop">Back to shop</Link></Button>
          {user?.role === "personnel" && <Button asChild variant="outline" className="w-full"><Link to="/" data-testid="cancel-dashboard-button"><LayoutDashboard size={15} className="mr-1.5" /> Dashboard</Link></Button>}
        </div>
      </div>
    </div>
  );
}
